import { NgClass } from '@angular/common';
import {
  type AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  type ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { RcpPopoverDirective } from '@reconcept-platform/shared/ui/standalone/popover';

@Component({
  selector: 'list-item-name',
  template: `
    <span
      class="label-grow ellipsis"
      [ngClass]="{ 'muted strike text': crossedOut }"
      #nameEl
      [rcpPopover]="name"
      [rcpPopoverIsEnabled]="showToolTip"
    >
      {{ name }}
    </span>
  `,
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  imports: [NgClass, RcpPopoverDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ListItemNameComponent implements AfterViewInit {
  @Input() name: string;
  @Input() crossedOut = false;

  @ViewChild('nameEl') nameEl: ElementRef;

  showToolTip: boolean;

  ngAfterViewInit() {
    // timeout needed because we need the element to be initialized to get the right widths.
    // then we update the binding [showIf] with the new value
    // without timeout, ExpressionChangedAfterHasBeenChecked error occurs.
    setTimeout(
      () => (this.showToolTip = this.nameEl.nativeElement.offsetWidth < this.nameEl.nativeElement.scrollWidth),
    );
  }
}
